import { ParamMap } from '@angular/router';
import { UriDelimiter } from '../models/emptyURIValue';
import { UrlQueryParams } from '../models/filter-form.interface';

/* eslint-disable no-restricted-syntax */
export type DirectoryParsedParams = {
  [URIPrefix.STATE]: string | null;
  [URIPrefix.CITY]: string | null;
  [URIPrefix.INSURANCE]: string;
  [URIPrefix.MODALITY]: string[];
  [URIPrefix.SPECIALTY]: string[];
  [URIPrefix.GENDER]: string[];
};
export enum URIPrefix {
  STATE = 'sta',
  CITY = 'cty',
  INSURANCE = 'ins',
  MODALITY = 'mod',
  SPECIALTY = 'spc',
  GENDER = 'gdr',
}
// Encodes URI but also encodes special characters. Specifically parentheses that we can have in insurance values.
// router.navigate fails to encode certain characters. This functions helps us handle cases like:  Optum/United-EAP (CO).
export const fixedEncodeURIComponent = (str: string) => encodeURIComponent(str).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16)}`);

export const ParseDirectoryFilterParams = (paramMap: ParamMap): DirectoryParsedParams => {
  // example URI - /sta-CO/cty-all/ins-aetna;mod-group,mod-family;spc-depression,spc-anxiety;gdr-man
  const state = paramMap.get(UrlQueryParams.STATE)?.split('-')[1]?.toUpperCase();
  const city = paramMap.get(UrlQueryParams.CITY)?.split('-')[1];
  const params: DirectoryParsedParams = {
    [URIPrefix.STATE]: state || null,
    [URIPrefix.CITY]: city ? decodeURIComponent(city) : null,
    [URIPrefix.INSURANCE]: '',
    [URIPrefix.MODALITY]: [],
    [URIPrefix.SPECIALTY]: [],
    [URIPrefix.GENDER]: [],
  };
  const filters = paramMap.get(UrlQueryParams.FILTERS);
  if (filters) {
    const filterSegments = filters.split(UriDelimiter);
    for (const segment of filterSegments) {
      const keyValuePairs = segment.split(',');
      for (const kvp of keyValuePairs) {
        const [key, value, extra] = kvp.split('-');
        let val = value;
        // Handle cases where there is a - in the value.
        if (extra) {
          val = [value, extra].join('-');
        }
        if (key && val) {
          if (key === URIPrefix.INSURANCE) {
            params[URIPrefix.INSURANCE] = decodeURIComponent(val);
          } else if ([URIPrefix.MODALITY, URIPrefix.SPECIALTY, URIPrefix.GENDER].includes(key as URIPrefix)) {
            (params[key as URIPrefix] as string[]).push(decodeURIComponent(val));
          }
        }
      }
    }
  }

  return params;
};
